'use strict';

var _themeSections = require('@shopify/theme-sections');

require('../sections/template-blog-article');

require('../sections/template-blog-instagram');

require('../sections/blog-filter');

require('../sections/blog-featured');

require('../../styles/templates/blog.scss');

(0, _themeSections.load)(['blog-featured', 'blog-filter', 'index-instagram', 'template-blog-article', 'template-blog-instagram']);